import {Component, OnInit} from '@angular/core';
import {PessoaService} from "../../../services/pessoa.service";
import {ListaSolicitante} from "../../../models/lista-solicitante";

@Component({
    selector: 'app-financeiro',
    templateUrl: './financeiro.component.html',
    styleUrl: './financeiro.component.css',
    standalone: false
})
export class FinanceiroComponent implements OnInit{
  loading = true;
  abaAtiva = 'dashboard';

  constructor(
    private pessoaService: PessoaService
  ) {
  }

  ngOnInit(): void {
    this.loading = false;
  }

  setAba(aba: string) {
    this.abaAtiva = aba;
  }
}
